import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useGroupMembership } from '@/hooks/useGroupMembership';
import { DrillInLayout } from '@/components/DrillInLayout';
import SideBetsFull from '@/components/SideBetsFull';
import { Loader2 } from 'lucide-react';

const SideBetsDrillIn = () => {
  const { groupId } = useParams<{ groupId: string }>();
  const { user } = useAuth();
  const { isMember, loading: membershipLoading } = useGroupMembership(groupId, user?.id);

  if (!membershipLoading && isMember === false) return <Navigate to="/" replace />;
  if (membershipLoading) return <div className="min-h-screen bg-background flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-accent" /></div>;

  return (
    <DrillInLayout title="הימורי צד" groupId={groupId!}>
      <SideBetsFull groupId={groupId!} />
    </DrillInLayout>
  );
};

export default SideBetsDrillIn;
